import { inViewport } from '@/helpers';
import { Campaign } from '@/models';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgMemberRewards',
})
export default class CmgMemberRewards extends Vue {
  shouldShowStickyHeader = false;

  async mounted() {
    window.addEventListener('scroll', this.onScroll, true);

    this.setLoadingStatus(true);
    try {
      await Promise.all([
        this.$services.reward.getExtrasCampaigns(),
        this.$services.reward.getRewardOffers(),
      ]);
    } finally {
      this.setLoadingStatus(false)
    }
  
    this.scrollToHash();
  }

  setLoadingStatus(loading: boolean) {
    this.$services.ui.setAppBlur(loading);
    this.$services.ui.setAppPepperVisibility(loading);
  }

  destroyed(): void {
    window.removeEventListener('scroll', this.onScroll, true);
  }

  get isCustomerStudent(): boolean {
    return this.$appStore.getters.isActiveStudent;
  }

  get isSummerOfExtrasEnabled(): boolean {
    return this.$appStore.state.featureFlags.featureFlags.isSummerOfExtrasEnabled;
  }

  get isRewardsOnline(): boolean {
    return this.$appStore.state.featureFlags.orderingStatus?.isRewardsOnline ?? true;
  }

  get isRewardsExchangeOnline(): boolean {
    return this.$appStore.state.featureFlags.orderingStatus?.isRewardsExchangeOnline ?? true;
  }

  get isServiceOnline(): boolean {
    return this.isRewardsOnline && this.isRewardsExchangeOnline && !this.$appStore.state.reward.unreachable;
  }

  get isSummerLeaderboardOnline(): boolean {
    return  this.summerExtraCampaign != null;
  }

  get campaigns(): Campaign[] {
    return this.$appStore.state.reward.campaigns;
  }
  get summerExtraCampaign(): Campaign | undefined {
    return this.campaigns.find(c => c.campaignType === 'summerExtra' && c.isMultiStepCampaign === false);
  }

  onScroll(): void {
    if (this.isServiceOnline) {
      this.shouldShowStickyHeader = !inViewport(this.$refs.loyaltyProgressHeader as Element);
    }
  }

  private scrollToHash() {
    if (!this.$route.hash) {
      return;
    }

    const routeHash: string = this.$route.hash.replace('#', '');
    const componentEl = document.getElementById(routeHash);

    if (componentEl) {
      this.$nextTick(() => componentEl.scrollIntoView());
    }
  }
}
